<form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6" novalidate>
  @if (errorMessage(); as msg) {
    <app-auth-alert>{{ msg | translate }}</app-auth-alert>
  }

  <!-- Lets password managers attach the new password to the right account -->
  <input type="email" name="username" autocomplete="username" [value]="email" class="hidden" aria-hidden="true" tabindex="-1" readonly>

  <div>
    <label for="new-password" class="field-label">{{ 'auth.reset.newPassword' | translate }}</label>
    <input type="password" id="new-password" formControlName="password" class="field" autocomplete="new-password" required>
    @if (fieldError(form.controls.password); as err) {
      <p class="mt-2 text-xs font-semibold text-red-600 dark:text-red-400">{{ err.key | translate: err.arg }}</p>
    } @else {
      <p class="mt-2 text-xs text-slate-500 dark:text-slate-400">{{ 'auth.passwordHint' | translate: minPasswordLength }}</p>
    }
  </div>

  <div>
    <label for="confirm-new-password" class="field-label">{{ 'auth.reset.confirmPassword' | translate }}</label>
    <input type="password" id="confirm-new-password" formControlName="confirmPassword" class="field" autocomplete="new-password" required>
    @if (fieldError(form.controls.confirmPassword); as err) {
      <p class="mt-2 text-xs font-semibold text-red-600 dark:text-red-400">{{ err.key | translate: err.arg }}</p>
    } @else if (form.hasError('passwordsMismatch') && form.controls.confirmPassword.touched) {
      <p class="mt-2 text-xs font-semibold text-red-600 dark:text-red-400">{{ 'auth.field.mismatch' | translate }}</p>
    }
  </div>

  <button type="submit" [disabled]="isLoading()" class="btn btn-primary w-full">
    @if (isLoading()) {
      <app-branded-loader mode="inline" [label]="'auth.reset.loading' | translate" />
    } @else {
      {{ submitLabel() | translate }}
    }
  </button>
</form>
